import { siteConfig } from "@/config/siteConfig";
import { Reveal } from "@/components/Reveal";

export const TrustStrip = () => (
  <section aria-label="Hizmet özellikleri" data-testid="trust-strip" className="border-b border-ink-100 bg-white">
    <div className="mx-auto grid max-w-6xl grid-cols-2 gap-x-4 gap-y-8 px-5 py-10 sm:grid-cols-3 md:py-12 lg:grid-cols-6">
      {siteConfig.trustStrip.map((item, i) => {
        const Icon = item.icon;
        return (
          <Reveal key={item.title + item.sub} delay={i * 0.05}>
            <div data-testid={`trust-item-${i}`} className="flex items-center gap-3.5">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border-2 border-brand/15 bg-brand-light text-brand">
                <Icon className="h-[22px] w-[22px]" aria-hidden="true" />
              </span>
              <p className="font-display text-sm font-extrabold leading-tight text-ink-900">
                {item.title}
                <span className="block text-xs font-semibold text-neutral-500">{item.sub}</span>
              </p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
